import { BotIcon, SettingsIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";

// Candidacy AI summary, or a placeholder while the backend is still writing
// it (search interests compute theirs after the interest is saved).
export const AiSummaryCard = ({
  isLoading = false,
  summary,
}: {
  isLoading?: boolean;
  summary?: string | null;
}) => {
  /* Render */
  const renderBody = () => {
    if (isLoading) {
      return (
        <Row className="items-center gap-2">
          <SettingsIcon className="h-3.5 w-3.5 shrink-0 animate-spin text-primary-900" />
          <Text className="text-sm font-normal leading-relaxed text-primary-900">
            Summarizing this candidate…
          </Text>
        </Row>
      );
    }
    return (
      <Text className="text-sm font-normal leading-relaxed text-[#121212] dark:text-[#FAFAFA]">
        {summary}
      </Text>
    );
  };

  const render = () => {
    if (!isLoading && !summary) return null;
    return (
      <Column className="rounded-xl border border-primary-300 bg-primary-300 pb-[18px] pl-5 pr-4 pt-3.5">
        <Row className="mb-2 items-center gap-1.5">
          <BotIcon className="h-3.5 w-3.5 text-primary-900" />
          <Text className="font-plex-mono text-[11px] font-medium uppercase tracking-wider text-primary-900">
            AI summary
          </Text>
        </Row>
        {renderBody()}
      </Column>
    );
  };

  return render();
};
